export default "__VITE_ASSET__CbQabGUb__"